module.exports = __webpack_public_path__ + "img/gs-img-1_ja.0709182e.png";